export function isAppRequest () {
  return $('body').hasClass('t-ios-app')
}
